import RecordBase from './Base';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

export default class CouponRecord extends RecordBase {
  static defaultAttributes = {
    name: '',
    promotion_type: '',
    discount_type: '',
    discount_value: 0,
    user_limit: 0,
    times_used: 0,
    start_date: '',
    expires_at: '',
    created_at: '',
    updated_at: '',
  };

  static _attributeNames = null;

  static get attributeNames() {
    const { t } = useTranslation();
    const trAttr = (attr) => t(`${attr}`);
    if (!this._attributeNames) {
      this._attributeNames = {
        name: trAttr('Cupom'),
        promotion_type: trAttr('Tipo de Promoção'),
        user_limit: trAttr('Limite de Usuários'),
        start_date: trAttr('Data de Início'),
        expires_at: trAttr('Data de Expiração'),
        discount_type: trAttr('Desconto'),
        discount_value: trAttr('Valor'),
        times_used: trAttr('Vezes Usado'),
        created_at: trAttr('Criado em'),
        updated_at: trAttr('Atualizado em')
      };
    }
    return this._attributeNames;
  }

  toParams(attrs = {}) {
    const {
      name,
      promotion_type,
      user_limit,
      start_date,
      expires_at,
      discount_type,
      discount_value,
      times_used,
      created_at,
      updated_at
    } = this.toObject();

    const formatedStartDate = moment(start_date).toISOString();
    const formatedEndDate = moment(expires_at).toISOString();

    return {
      data: {
        attributes: {
          name,
          discount_value,
          discount_type: discount_type,
          promotion_type,
          expires_at: formatedEndDate,
          start_date: formatedStartDate,
          user_limit,
          times_used,
          created_at: created_at,
          updated_at: updated_at,
          ...attrs
        },
      },
    };
  }
}
